import { Box, Button } from '@mui/material';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import defaultLogo from '@/assets/imgs/defaultlogo.png';
import { useOrganizationId } from '@/contexts/OrganizationContext';
import { ROUTES } from '@/routes';
import { useTheme } from '@/theme';

// Style constants
const LOGO_STYLES = {
  maxHeight: '5.75rem',
  width: '9.25rem',
} as const;

interface AdminNavbarProps {
  className?: string;
}

function AdminNavbar({ className }: AdminNavbarProps) {
  const theme = useTheme();
  const { setOrganizationId } = useOrganizationId();
  const navigate = useNavigate();

  const exitButtonRef = useRef<HTMLButtonElement | null>(null);

  const handleExitAdmin = () => {
    setOrganizationId(0);
    navigate(ROUTES.HOME);
  };

  return (
    <nav className={className}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <Box component='img' src={defaultLogo} alt='Hub Nexus' sx={LOGO_STYLES} />
        <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <Button
            ref={exitButtonRef}
            variant='contained'
            sx={{
              height: '36px',
              fontSize: '14px',
              boxShadow: 'none',
              textTransform: 'none',
              fontWeight: theme.hhglobal.typography.fontWeights.regular,
              '&:active': {
                backgroundColor: theme.hhglobal.neutral.gray900,
                color: theme.palette.common.white,
              },
              '&:disabled': {
                backgroundColor: theme.hhglobal.neutral.gray600,
                color: theme.palette.common.white,
              },
            }}
            data-testid='exit-admin-button'
            onClick={handleExitAdmin}
          >
            Exit Admin
          </Button>
        </Box>
      </Box>
    </nav>
  );
}

export default AdminNavbar;
